module.exports = __webpack_public_path__ + "static/media/clarityLogo.28d1969a.svg";